export default __webpack_public_path__ + "static/media/email-marketingimg1.41ab3b4b.png";